var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51814 0C3.7831 0 3.99795 0.21485 3.99795 0.479811V2.07933C3.99795 2.34429 3.7831 2.55914 3.51814 2.55914C3.25318 2.55914 3.03833 2.34429 3.03833 2.07933V0.479811C3.03833 0.21485 3.25318 0 3.51814 0Z",
    fill: "#62C776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63763 1.58033C4.63523 1.74147 4.71655 1.89225 4.85233 1.97897C6.05846 2.71579 6.4388 4.29101 5.70183 5.49698C4.96486 6.70296 3.38979 7.08345 2.18381 6.34648C0.977684 5.60966 0.597346 4.03445 1.33432 2.82847C1.54481 2.48384 1.83408 2.19397 2.17811 1.98242C2.31629 1.8957 2.39956 1.74372 2.39851 1.58063C2.39926 1.31567 2.18501 1.10022 1.92005 1.09947C1.82898 1.09917 1.73986 1.12482 1.66274 1.17343C0.0117602 2.19877 -0.495207 4.36827 0.53013 6.01926C1.55547 7.67009 3.72512 8.17705 5.37595 7.15172C7.02678 6.12638 7.53375 3.95673 6.50841 2.3059C6.22305 1.84634 5.83551 1.4588 5.37595 1.17343C5.15105 1.0315 4.85383 1.09887 4.7119 1.32377C4.66344 1.40059 4.63763 1.48956 4.63763 1.58033Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.295f37c9b8bfa7fc0da8c9965588a75e.svg";
export { ForwardRef as ReactComponent };